module.exports = __webpack_public_path__ + "img/ic-ic-now-counsel-pop.f2620990.svg";